// const mapKey = '993d5132454e8e82401fd2db93c87366'
const mapKey = 'b35f9960712b88d422ec57717cee8001'
const requestWhite = [
  '/feign/',
  '/webjars/',
  '/druid/',
  '/app/',
  '/api/',
  '/sys/login',
  '/swagger/',
  '/v2/api-docs',
  '/swagger-ui.html',
  '/swagger-resources/',
  '/captcha.jpg',
  '/redis/captcha.jpg',
  '/xg/pigeon/featherList',
  '/sys/dict/dictEnum',
  '/xg/shed/getShedListByArea',
  '/sys/footNoInterval/list',
  '/xg/pigeon/verifyFootNo',
  '/sys/oss/fileUpload',
  '/sys/oss/fileUpload2Map',
  '/filesys/oss/fileUpload2Map',
  '/filesys/oss/fileUpload',
  '/sys/sendCode',
  '/sys/user/checkSysUserMobile',
  '/sys/checkMobileSmsCode',
  '/es/',
  '/sys/dict/LRType',
  '/auction/auction/sale/getArticleId'
]
const appointAwardDataTypeId = ['2','3','5','6','9','11','19']
export {
  mapKey,
  requestWhite,
  appointAwardDataTypeId
}
